var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("app-search-browse", {
    attrs: { "data-source": _vm.dataSource },
    on: {
      click: function ($event) {
        return _vm.onClick($event)
      },
    },
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }